<ng-container *ngIf="!afterChangePasswordSuccess; else changeSuccess">
  <div class="change-password-page d-flex justify-content-center align-items-center p-3 p-md-4">
    <div class="change-password-card w-100">
      <form *ngIf="changePasswordForm" [formGroup]="changePasswordForm" (ngSubmit)="submitForm()" class="login-form w-100">
        <div class="d-flex justify-content-center mb-3">
          <img class="key-img" src="assets/images/key.png" alt="key img" />
        </div>
        <div class="text-center mb-4">
          <h1 class="form-title mb-2">Change Password</h1>
          <p class="form-subtitle mb-0">Keep your account secure by setting a strong new password.</p>
        </div>

        <div class="form-input">
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input type="text" matInput placeholder="" formControlName="email">
          </mat-form-field>
        </div>

        <div class="form-input">
          <mat-form-field appearance="outline">
            <mat-label>Current Password</mat-label>
            <input [type]="oldPasswordVisible ? 'password' : 'text'" matInput placeholder="" formControlName="old_password">
            <mat-error
              *ngIf="changePasswordForm.invalid && (changePasswordForm.get('old_password')?.dirty || changePasswordForm.get('old_password')?.touched )">
              <span *ngIf="changePasswordForm.get('old_password')?.hasError('required')">
                Please enter your current password.
              </span>
              <span *ngIf="changePasswordForm.get('old_password')?.hasError('minlength')">
                Password needs to be at least 8 characters long.
              </span>
            </mat-error>
            <button type="button" class="input-icon-btn" (click)="setInputType('old')" onKeyDown="doNothing()" tabindex="0">
              <mat-icon matSuffix>
                {{!oldPasswordVisible ? 'visibility' : 'visibility_off'}}
              </mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="form-input">
          <mat-form-field appearance="outline">
            <mat-label>New Password</mat-label>
            <input [type]="newPasswordVisible ? 'password' : 'text'" matInput placeholder="" formControlName="new_password">
            <mat-hint>
              <img src="assets/icons/right_tick_black.svg" [ngClass]="{'filter-green': isPasswordValid()}" alt="key img"
                width="9px" height="10px" /> Minimum 8 characters
            </mat-hint>
            <mat-hint align="end">{{changePasswordForm.get('new_password')?.value.length}}/8</mat-hint>
            <mat-error
              *ngIf="changePasswordForm.invalid && (changePasswordForm.get('new_password')?.dirty || changePasswordForm.get('new_password')?.touched )">
              <span *ngIf="changePasswordForm.get('new_password')?.hasError('required')">
                Please enter your new password.
              </span>
            </mat-error>
            <button type="button" class="input-icon-btn" (click)="setInputType('new')" onKeyDown="doNothing()" tabindex="0">
              <mat-icon matSuffix>
                {{!newPasswordVisible ? 'visibility' : 'visibility_off'}}
              </mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="form-input mt-2">
          <mat-form-field appearance="outline">
            <mat-label>Confirm New Password</mat-label>
            <input [type]="cNewPasswordVisible ? 'password' : 'text'" matInput placeholder="" formControlName="c_new_password">
            <mat-error *ngIf="!isPasswordMatched">
              New Password and Confirm Password does not match.
            </mat-error>
            <mat-error
              *ngIf="changePasswordForm.invalid && (changePasswordForm.get('c_new_password')?.dirty || changePasswordForm.get('c_new_password')?.touched )">
              <span *ngIf="changePasswordForm.get('c_new_password')?.hasError('required')">
                Please enter your new password again.
              </span>
            </mat-error>
            <button type="button" class="input-icon-btn" (click)="setInputType('c_new')" onKeyDown="doNothing()" tabindex="0">
              <mat-icon matSuffix>
                {{!cNewPasswordVisible ? 'visibility' : 'visibility_off'}}
              </mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="mt-3">
          <button class="form-btn" mat-stroked-button type="submit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</ng-container>
<ng-template #changeSuccess>
  <div class="change-password-page d-flex justify-content-center align-items-center p-3 p-md-4">
    <div class="change-password-card success-card">
      <div class="text-center mb-2">
        <h1 class="form-title mb-3">
          Fantastic!
          <br>
          Password has changed successfully.
        </h1>
        <span class="success-note">You're all set to login with your new credentials.</span>
        <div class="mt-4">
          <button class="form-btn" mat-stroked-button (click)="gotoLogin()" type="button">Go to Login</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>